export default __webpack_public_path__ + "static/media/electricScooter.8f0dfde4.svg";